/** The history icon both panes put on a revised action, and the history dialog it opens. */
export const ACTION_HISTORY_TEXTS = {
  DIALOG_TITLE: 'Action history',
  ORIGINAL: 'Recommended by Clive',
  REVISED: 'Revised',
  SHOW_EARLIER: 'Show earlier versions',
  TRY_AGAIN: 'Try again',
};
